import { render, staticRenderFns } from "./DialogAlertLevelChange.vue?vue&type=template&id=3972aee4"
import script from "./DialogAlertLevelChange.js?vue&type=script&lang=js&external"
export * from "./DialogAlertLevelChange.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports